import { useNavigate } from 'react-router-dom';
import useInView from '../../../hooks/useInView';

const areas = [
  'Tampa, FL', 'St. Petersburg, FL', 'Clearwater, FL', 'Sarasota, FL',
  'Orlando, FL', 'Kissimmee, FL', 'Sanford, FL', 'Winter Park, FL',
  'Miami, FL', 'Fort Lauderdale, FL', 'West Palm Beach, FL', 'Boca Raton, FL',
  'Fort Myers, FL', 'Cape Coral, FL', 'Naples, FL', 'Bonita Springs, FL',
  'Jacksonville, FL', 'Ocala, FL', 'Gainesville, FL', 'Daytona Beach, FL',
];

const ServiceAreasHome = () => {
  const navigate = useNavigate();
  const { ref: leftRef, inView: leftInView } = useInView();
  const { ref: rightRef, inView: rightInView } = useInView();

  return (
    <section id="areas" className="py-10 md:py-16 bg-[#EEF5FF]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div
            ref={leftRef}
            className={`transition-all duration-800 ease-out ${leftInView ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-10'}`}
          >
            <p className="text-[#C41E3A] text-sm font-bold uppercase tracking-widest mb-3">Where We Operate</p>
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-[#111827] mb-5 sm:mb-6">
              Proudly Serving Florida
            </h2>
            <p className="text-base sm:text-lg text-[#6B7280] mb-6 sm:mb-8 leading-relaxed">
              Renova is Florida&apos;s full-service home comfort company. From Tampa Bay to South Florida, we bring the same professional standard to every home we serve.
            </p>

            <div className="grid grid-cols-2 gap-2 sm:gap-3 mb-6 sm:mb-8">
              {areas.slice(0, 12).map((a, i) => (
                <div
                  key={a}
                  style={{ transitionDelay: `${i * 50}ms` }}
                  className={`flex items-center space-x-2 text-sm text-[#374151] transition-all duration-500 ease-out ${leftInView ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-4'}`}
                >
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-map-pin-2-fill text-[#C41E3A] text-xs" />
                  </div>
                  <span>{a}</span>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row gap-3">
              <button
                onClick={() => navigate('/service-areas')}
                className="bg-[#1A56A0] text-white px-6 py-3 rounded-lg text-sm font-semibold hover:bg-[#154A8C] transition-colors whitespace-nowrap cursor-pointer"
              >
                View All Florida Areas
              </button>
              <button
                onClick={() => navigate('/book-appointment')}
                className="border border-[#1A56A0] text-[#1A56A0] px-6 py-3 rounded-lg text-sm font-semibold hover:bg-[#1A56A0] hover:text-white transition-colors whitespace-nowrap cursor-pointer"
              >
                Check My Zip Code
              </button>
            </div>
          </div>

          <div
            ref={rightRef}
            style={{ transitionDelay: '150ms' }}
            className={`relative rounded-2xl overflow-hidden transition-all duration-900 ease-out ${rightInView ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-10'}`}
          >
            <iframe
              title="Renova Florida Service Areas"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3628947.8!2d-81.5158!3d27.6648!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88c1766591562abf%3A0xf72e13d35bc74ed0!2sFlorida!5e0!3m2!1sen!2sus!4v1234567890"
              width="100%"
              height="320"
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="w-full sm:h-[440px]"
              style={{ height: '320px' }}
            />
            <div className="absolute top-4 left-4 bg-white rounded-lg px-4 py-2 border border-[#E2E8F0]">
              <p className="text-xs font-bold text-[#0C2340]">Statewide Florida Coverage</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceAreasHome;
